var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportSelectAppraiserCard.title")) + " "), _c('v-spacer'), _c('m-icon-button', {
    attrs: {
      "icon": _vm.selectAppraiserIcon,
      "disabled": _vm.report.isAppraiserCompanyLoading || _vm.isUpdatingReport
    },
    on: {
      "click": _vm.openDialog
    }
  })], 1), _c('v-card-text', [!_vm.appraiserCompanyId ? _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportSelectAppraiserCard.noAppraiserText')
    }
  }) : _vm.report.isAppraiserCompanyLoading || _vm.isUpdatingReport ? _c('v-skeleton-loader', {
    staticClass: "mb-2",
    attrs: {
      "type": "image",
      "height": "124"
    }
  }) : _vm.report.appraiserCompany ? _c('company-sheet', {
    attrs: {
      "company": _vm.report.appraiserCompany
    }
  }) : _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportSelectAppraiserCard.loadingError')
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("components.PartnerReportDetail.repair.PartnerReportSelectAppraiserCard.title"),
      "isDialogActive": _vm.selectAppraiserDialog,
      "rightLoading": _vm.isUpdatingReport,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.selectAppraiserDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.selectAppraiserDialog = $event;
      },
      "rightClick": _vm.selectAppraiser
    }
  }, [_c('company-selection', {
    attrs: {
      "filter": _vm.filter
    },
    model: {
      value: _vm.localAppraiserCompany,
      callback: function callback($$v) {
        _vm.localAppraiserCompany = $$v;
      },
      expression: "localAppraiserCompany"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }